import { pick } from 'lodash';
import { _asArray } from '@monobits/core';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * Getter for motion values from the theme context (global & specific scope).
 *
 * @param  {object} context Theme UI context
 * @param  {Array.<string>} [names=[]] Name and or variant name
 * @param  {Array.<string>} [extend=[]] Array of object keys to include
 * @return {Object}
 */


var getMotion = function getMotion(context, names, extend) {
  var _context$theme, _context$theme$motion, _context$theme2, _context$theme2$varia;

  if (names === void 0) {
    names = [];
  }

  if (extend === void 0) {
    extend = [];
  }

  var array = {
    extend: _asArray(extend),
    names: _asArray(names)
  };
  var _array$names = array.names,
      name = _array$names[0],
      variant = _array$names[1];

  var merge = _extends({}, (_context$theme = context.theme) == null ? void 0 : (_context$theme$motion = _context$theme.motion) == null ? void 0 : _context$theme$motion[name], (_context$theme2 = context.theme) == null ? void 0 : (_context$theme2$varia = _context$theme2[variant]) == null ? void 0 : _context$theme2$varia.motion);

  return pick(merge, ['animate', 'transition'].concat(array.extend));
};

export { getMotion };